export interface ShipperSpec {
  id: number;
  name: string;
}

export const KnownShipperSpecs: ShipperSpec[] = [
  { id: 0, name: 'All' },
  { id: 1, name: 'UPS Canada Standard' },
  { id: 2, name: 'UPS US Standard' },
  { id: 3, name: 'FedEx Canada Standard' },
  { id: 4, name: 'FedEx US Standard' },
  { id: 5, name: 'Canada Post Standard' },
  { id: 6, name: 'US Post First Class' },
  { id: 7, name: 'US Post Priority' },
  { id: 8, name: 'Dicom Parcel' },
  { id: 9, name: 'DHL Express' },
  { id: 10, name: 'UPS US Express' },
  { id: 11, name: 'UPS Canada Express' },
  { id: 12, name: 'Iber Customer Pickup' },
  { id: 14, name: 'UPS CA to US Ground' },
];

export const KnownRetailShippers: ShipperSpec[] = [
  {
    id: 5,
    name: 'UPS US',
  },
  {
    id: 2,
    name: 'USPS',
  },
  {
    id: 4,
    name: 'UPS Canada',
  },
  {
    id: 6,
    name: 'FedEx Canada',
  },
  {
    id: 7,
    name: 'FedEx US',
  },
  {
    id: 1,
    name: 'Canada Post',
  },
  {
    id: 8,
    name: 'Dicom',
  },
  {
    id: 9,
    name: 'DHL',
  },
  {
    id: 10,
    name: 'Iber Store',
  },
  {
    id: 11,
    name: 'UPS Canada (US)',
  },
];

export const getShipperName = (id: number | undefined) => {
  let filteredList: ShipperSpec[] = KnownShipperSpecs.filter((x) => x.id === id);
  return filteredList.length === 1 ? filteredList[0].name : 'N/A';
};

export const getRetailShipperName = (id: number | undefined) => {
  let filteredList: ShipperSpec[] = KnownRetailShippers.filter((x) => x.id === id);
  return filteredList.length === 1
    ? filteredList[0].name === 'Dicom'
      ? 'GLS'
      : filteredList[0].name
    : 'N/A';
};

export const getTrackingUrlByCarrier = (id: number, trackingNumber: string | null) => {
  if (!trackingNumber) return null;
  switch (id) {
    case 5:
    case 2:
    case 4:
      return `https://www.ups.com/track?track=yes&trackNums=${trackingNumber}&loc=en_US&requester=ST/`;
    case 6:
    case 7:
      return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`;
    case 1:
      return `https://www.canadapost-postescanada.ca/track-reperage/en#/details/${trackingNumber}`;
    case 8:
      return `https://gls-canada.com/en/dicom/tracking`;
    case 9:
      return `https://www.dhl.com/ca-en/home/tracking.html?tracking-id=${trackingNumber}`;
    default:
      return null;
  }
};
